import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import {htmlToText} from '../../../../helpers/utils'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const useStyles = makeStyles(openQuestionStyles)

export default function OpenQuestion ({context,  question}) {

  const classes = useStyles()
  const {quizAssessmentResults: assessment, translate} = context

  const expected = htmlToText(question.answer.html)

  const {answers = {}} = assessment 
  const answer = answers[question.id] || {}

  return (
    <Box className={classes.root}>
      <Box className={classes.studentAnswer}>
        <TextareaAutosize
          className={classes.textarea}
          maxRows={5}
          minRows={5}
          value={answer.value}
          readOnly
        />
      </Box>
      <Box className={classes.correctAnswer}>
        <Box className="label">
          <Box className={classes.correct}><CheckCircleIcon /></Box>
          <Box>{translate('expected-answer')}</Box>
        </Box>
        <TextareaAutosize
          className={classes.textarea}
          maxRows={5}
          minRows={5}
          value={expected}
          readOnly
        />
      </Box>
    </Box>
  );
}

function openQuestionStyles (theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      paddingBottom: 20,
      flexDirection: 'column',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        '&:last-child': {
          marginTop: 20
        },
        '& .label': {
          display: "flex",
          marginBottom: 10 ,
          fontWeight: 'bold',
          '& > div': {
            ...verticalCentering
          }
        }
      }
    },
    correct: {
      marginRight: 5,
      '& svg': {
        fill: '#27bc58',
      },
    },
    textarea: {
      resize: 'none',
      width: 'auto',
      padding: 8,
      flexGrow: 1,
      borderRadius: '4px',
      border: 'solid 1px #c2c7ca',
    },
  }
}
